<template>
  <!-- Error boundary catches config validation errors and shows user-friendly message -->
  <ConfigErrorBoundary>
    <FileCompressor
      :config="compressorConfig"
      @batch-created="handleBatchCreated"
      @job-completed="handleJobCompleted"
      @batch-cleared="handleBatchCleared"
      @error="handleError"
      @credits-updated="handleCreditsUpdated"
    />
  </ConfigErrorBoundary>
</template>

<script setup lang="ts">
import FileCompressor from './FileCompressor.vue';
import ConfigErrorBoundary from './ConfigErrorBoundary.vue';
import { parseAndValidateCompressorConfig } from '../utils/ConfigValidator';

// Parse and validate configuration using fail-fast Zod validation
const compressorConfig = parseAndValidateCompressorConfig('universal-compressor', 'Universal Compressor');

// Event handlers
function handleBatchCreated(batchId: string) {
  console.log('[Universal Compressor] Batch created:', batchId);
}

function handleJobCompleted(jobId: string) {
  console.log('[Universal Compressor] Job completed:', jobId);
}

function handleBatchCleared() {
  console.log('[Universal Compressor] Batch cleared');
}

function handleError(error: Error) {
  console.error('[Universal Compressor] Error:', error);
}

function handleCreditsUpdated(credits: number) {
  console.log('[Universal Compressor] Credits updated:', credits);
}
</script>
